import type { Creds } from './crmConnectionActions'

export const selectCRMAuthKeyValue = (creds: Creds[] | undefined) =>
  creds?.[0]?.auth_key_value || ''
